export default "__VITE_ASSET__DgT_oURb__"